import { ReactNode } from 'react'
import { cn } from '../lib/utils'

interface MetricCardProps {
  title: string
  value: string | number
  subtitle?: string
  trend?: {
    value: string
    positive: boolean
  }
  children?: ReactNode
  className?: string
}

export function MetricCard({ title, value, subtitle, trend, children, className }: MetricCardProps) {
  return (
    <div className={cn(
      'bg-white rounded-lg border border-gray-200 p-6 shadow-sm',
      className
    )}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="mt-2 text-3xl font-bold text-gray-900">{value}</p>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          )}
          {trend && (
            <div className="mt-2 flex items-center">
              <span className={cn(
                'text-sm font-medium',
                trend.positive ? 'text-green-600' : 'text-red-600'
              )}>
                {trend.positive ? '+' : ''}{trend.value}
              </span>
            </div>
          )}
        </div>
        {children && (
          <div className="ml-4">
            {children}
          </div>
        )}
      </div>
    </div>
  )
}